import { useAppDispatch } from '../../app/hooks';
import { fetchWallet } from '../wallet/walletSlice';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import ThemeSwitch from "../../theme/ThemeSwitch";
export default function Search(props:any) {
    const dispatch = useAppDispatch();
    const { themeToggler, walletAddress, setWalletAddress, theme} = props
    const [storedWallet, setStoredWallet] = useState('')

    const changeHandler = (event:any) => {
        event.preventDefault()
        return setWalletAddress(event.target.value)
    }

    const handleSubmit = (event:any) => {
        event.preventDefault()
        const localItem:any = localStorage.getItem('WalletAddress')
        if(localItem !== walletAddress){
            localStorage.removeItem('WalletAddress')
            localStorage.setItem('WalletAddress', walletAddress)
        }
        return setWalletAddress(walletAddress)
    }

    useEffect(() => {
        const item:any = localStorage.getItem('WalletAddress')
        setStoredWallet(item)
        if(storedWallet){
            dispatch(fetchWallet(storedWallet))
        }
    }, [storedWallet, dispatch])



    return (
        <StyledForm onSubmit={(event:any) => handleSubmit(event)}>
            <StyledLabel>
                <StyledHeading>Rune Portfolio Lookup</StyledHeading>
                <StyledDiv >
                <StyledThemeSwitch>
                    <ThemeSwitch theme={theme} themeToggler={themeToggler}>Theme</ThemeSwitch>
                </StyledThemeSwitch>
                    <StyledInput theme={theme} onChange={event => changeHandler(event)} type='text' value={'' ? '' : walletAddress} placeholder='Address' />
                    <StyledButton onClick={() => dispatch(fetchWallet(walletAddress))} type='submit'>Search</StyledButton>
                </StyledDiv>
            </StyledLabel> 
        </StyledForm>
    )
}

const StyledThemeSwitch = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  margin-right:3%;
`
const StyledDiv = styled.div`
    width:100%;
    display:flex;
    justify-content:center;
`

const StyledHeading = styled.h1`
    font-size:5rem;
    @media(max-width:1000px){
    font-size:3.5rem;
    }
    @media(max-width:750px){
    font-size:3rem;
    }
    @media(max-width:600px){
    font-size:2.5rem;
    }
    @media(max-width:450px){
    font-size:2rem;
    }
`
const StyledForm = styled.form`
    width:100%;
    border-bottom: 2px solid black;
    display:flex;
    justify-content:center;
    padding-bottom:3%;

`

const StyledButton = styled.button`
    padding:1%;
    background-color:#989c9f;
    font-size:1.5rem;
    @media(max-width:850px){
        font-size:1.25rem;
    }
`

const StyledInput = styled.input`
    padding:1%;
    width:30%;
    border-radius:5px;
    border: 3px solid black;
    background-color:${(props:any) => (props.theme === 'dark' ? '#a7bcc9': 'white' )};
    font-size:1.2rem;
    @media(max-width:750px){
        width:36%;
        border-radius:3px;
        border: 2px solid black;
    }
`

const StyledLabel = styled.label`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
`